export default __webpack_public_path__ + "6ceb0199e5e49967f6e9e2479a1ae6f5.png";